module.exports = __webpack_public_path__ + "img/card9.60c8c7d8.png";